import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";

import Modal from "../../../components/common/modal/Modal";
import { Loader } from "../../../components/common/Loader";
import ButtonComponent from "../../../components/common/button/Button";
import JobDetailInputData from "./JobDetailInputData";
import { editJobDetailsApi } from "../../../redux/actions/EditJobDetails";
import { editJobDetailsEndpoint } from "../../../common/endpoints";

const modesOfTrans = [
  { value: "Road LTL", label: "Road LTL" },
  { value: "Road FTL", label: "Road FTL" },
  { value: "Pickup", label: "Pickup" },
  { value: "Air", label: "Air" },
  { value: "Sea", label: "Sea" },
  { value: "Shipping Instruction 1", label: "Shipping Instruction 1" },
  { value: "Shipping Instruction 2", label: "Shipping Instruction 2" },
];

const JobDetailModal = ({ open, handleClose, title, seqId, setOpneJobDetailModal, fetchDataFromScheduledJobs }) => {
  const dispatch = useDispatch();
  const getJobDetailsData = useSelector((state) => state?.getJobInputDetail);
  const [scheduleValue, setScheduleValue] = useState(getJobDetailsData?.data?.cronExp);
  const [scheduleType] = useState("Single-Run");
  const [selectedModesOfTransport, setSelectedModesOfTransport] = useState([]);
  const [scheduledTime, setScheduledTime] = useState("");
  const [scheduledStartDate, setScheduledStartDate] = useState(getJobDetailsData?.data?.scheduleStartDate || null);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([
    { range: "Range 1", excludeFromDate: null, excludeToDate: null },
  ]);
  const [formData, setFormData] = useState({
    plant: [],
    fromDate: getJobDetailsData?.data?.periodFrom || null,
    toDate: getJobDetailsData?.data?.periodTo || null,
    excludeRange: false,
    prodCriticalItem: getJobDetailsData?.data?.scheduleLabel || "",
    materialTypeDesc: getJobDetailsData?.data?.scheduleDescription || "",
  });
  const [excludeModalBtnDisabled, setExcludeModalBtnDisabled] = useState(true);
  const [singleDropdownData] = useState({
    plant: "",
    incotermLocation: getJobDetailsData?.data?.incotermsLocations || [],
    supplierId: getJobDetailsData?.data?.supplierIds || [],
    modeOfTransports: getJobDetailsData?.data?.modeOfTransports || [],
    materialId: getJobDetailsData?.data?.materialIds || [],
    excludeRanges: getJobDetailsData?.data?.excludeRanges || [],
    scheduleStartTime: '',
  });
  const [plantData, setPlantData] = useState([]);
  const [isModalBtnDisabled, setIsModalBtnDisabled] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const userEmail = localStorage.getItem("data");

  const handleDateChange = (date, name) => {
    console.log('date', date);
    setFormData({
      ...formData,
      [name]: date,
    });
  };

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  };

  const handleAddRows = () => {
    setRows([
      ...rows,
      {
        range: `Range ${rows.length + 1}`,
        excludeFromDate: null,
        excludeToDate: null,
      },
    ]);
  };

  const delRowHandler = (index) => {
    const newArray = rows.filter((rows, i) => i !== index && rows);
    setRows(newArray);
  };

  const handleExcludeDateChange = (date, name, index) => {
    date && setIsModalBtnDisabled(false);
    setRows(
      rows.map((row, i) => (i === index ? { ...row, [name]: date } : row))
    );
    setExcludeModalBtnDisabled(false);
  };

  const clearAllInputSelection = () => {
    setBtnDisabled(true);
    setScheduledTime("");
    setScheduledStartDate("");
    setPlantData([]);
    setSelectedModesOfTransport([]);
    setFormData((prevFormData) => ({
      ...prevFormData,
      plant: [],
      fromDate: "",
      toDate: "",
      excludeRange: false,
      prodCriticalItem: "",
      materialTypeDesc: "",
    }));
  };

  const clearAllExcludeModal = () => {
    setRows(
      rows.map((row) => ({
        ...row,
        excludeFromDate: null,
        excludeToDate: null,
      }))
    );
    setIsModalBtnDisabled(true);
    setExcludeModalBtnDisabled(true);
  };

  const submitExcludeModalHandler = () => {
    setFormData({ ...formData, excludeRange: true });
    setShowModal(false);
    setBtnDisabled(true);
  };

  const handleEditRange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
    setShowModal(true);
  };

  const editScheduledJobHandler = async () => {
    setLoading(true);
    try {
      const response = await dispatch(editJobDetailsApi({
        dynamicEndpoint: `${editJobDetailsEndpoint}/${seqId}`,
        data: {
          userEmail: userEmail,
          plantName: "5040",
          supplierIds: singleDropdownData?.supplierId,
          materialIds: singleDropdownData?.materialId,
          incotermsLocations: singleDropdownData?.incotermLocation,
          modeOfTransports: singleDropdownData?.modeOfTransports,
          periodFrom: formData?.fromDate,
          periodTo: formData?.toDate,
          excludeRanges: singleDropdownData?.excludeRanges,
          scheduleLabel: formData?.prodCriticalItem,
          scheduleDescription: formData?.materialTypeDesc,
          scheduleType: scheduleType,
          cronExp: scheduleValue,
          scheduleStartDate: scheduledStartDate,
          scheduleStartTime: scheduledTime,
        },
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        },
    }));
      if (response.meta.requestStatus === "fulfilled") {
        setLoading(false);
        toast.success(`${response?.payload}`, {
          autoClose: 2000,
        })
        setOpneJobDetailModal(false);
        fetchDataFromScheduledJobs();
      } else {
        toast.error(`Something went wrong, Please try again`, {
          autoClose: 2000,
        })
      }
    } catch (error) {
      toast.error(`Something went wrong, Please try again`, {
        autoClose: 2000,
      })
    }
  }

  return (
    <>
        <Modal
          open={open}
          handleClose={handleClose}
          title={title}
          fullWidth={true}
          maxWidth="xl"
          content={
            <>
            {getJobDetailsData?.loading || loading ? (
              <Loader />
            ) : (
              <JobDetailInputData
                rows={rows}
                formData={formData}
                showModal={showModal}
                handleDateChange={handleDateChange}
                handleChange={handleChange}
                handleAddRows={handleAddRows}
                delRowHandler={delRowHandler}
                handleExcludeDateChange={handleExcludeDateChange}
                clearAllExcludeModal={clearAllExcludeModal}
                submitExcludeModalHandler={submitExcludeModalHandler}
                handleClose={handleClose}
                clearAllInputSelection={clearAllInputSelection}
                isModalBtnDisabled={isModalBtnDisabled}
                btnDisabled={btnDisabled}
                scheduleType={scheduleType}
                scheduleValue={scheduleValue}
                setScheduleValue={setScheduleValue}
                handleEditRange={handleEditRange}
                excludeModalBtnDisabled={excludeModalBtnDisabled}
                allPlantData={getJobDetailsData?.data?.dropdownData}
                modesOfTrans={modesOfTrans}
                selectedModesOfTransport={selectedModesOfTransport}
                setSelectedModesOfTransport={setSelectedModesOfTransport}
                scheduledTime={scheduledTime}
                setScheduledTime={setScheduledTime}
                scheduledStartDate={scheduledStartDate}
                setScheduledStartDate={setScheduledStartDate}
                setBtnDisabled={setBtnDisabled}
                fromDate={formData?.fromDate}
                toDate={formData?.toDate}
                singleDropdownData={singleDropdownData}
                plantData={plantData}
              />
              )}
            </>
          }
          action={
            <Grid sx={{ display: "flex", gap: "16px" }}>
              <ButtonComponent
                maxWidth="170px"
                label="Cancel"
                bgColor="white"
                color="black"
                onClick={handleClose}
              />
              <ButtonComponent
                maxWidth="170px"
                label="Save"
                bgColor="black"
                color="white"
                onClick={editScheduledJobHandler}
              />
            </Grid>
          }
        />
    </>
  );
};

export default JobDetailModal;
